import React from "react";

//  developer component
function Developer() {
  return (
    <div className="developer">
      <a
        href="https://github.com/ibrahim11elian"
        target="_blank"
        rel="noreferrer"
      >
        <div className="img" alt="ibrahim ahmed elian" />
      </a>
      <div className="div-by">created with ❤ by ibrahim ahmed elian</div>
    </div>
  );
}

export default Developer;
